/* eslint-disable class-methods-use-this */
import Component from '@bythepixel/component-loader';
import LeadForm from '@Core/components/leadForm';

export default class PromotionModalForm extends Component {
  static selector = '[data-comp-promotion-modal-form]';

  LIVEWIRE_REFRESH_DELAY = 200;

  constructor(containerEl) {
    super(containerEl);

    this.mount();
  }

  attachListeners() {
    window.addEventListener('promotions:refresh-modal-components', () => {
      this.refreshFormComponent();
    });
  }

  refreshFormComponent() {
    setTimeout(() => {
      this.form = new LeadForm(this.formContainer);
    }, this.LIVEWIRE_REFRESH_DELAY);
  }

  get formContainer() {
    return this.$container.querySelector(LeadForm.selector);
  }

  mount() {
    this.attachListeners();
  }
}
